import { useRouter } from 'next/router';
import React from 'react';

import ListPageStates from '@/src/shared/components/ListPage/ListPageStates';
import useListSearch from '@/src/shared/hooks/useListSearch';
import states from '@/utils/states';

const searchOptions = {
  pubCode: 687,
  yearsBack: 5,
};

const LegislativeWrapUp = props => {
  const router = useRouter();
  const { statecode } = props;
  const _statecode = router.query.slug || statecode;
  const [loading, results] = useListSearch(searchOptions, _statecode);

  return (
    <ListPageStates
      title="Legislative Wrap-Up"
      results={results}
      truncateResultSummary
      searchOptions={searchOptions}
      statecode={_statecode}
      routeBase="/advocacy/state/legislative-wrap-up"
      heroContent={<p>Documents from the last 5 years</p>}
      loading={loading}
    />
  );
};

export async function getStaticPaths() {
  return {
    paths: states.map(s => ({ params: { slug: s.StateCode } })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  return {
    props: {
      statecode: params.slug || 0,
    },
  };
}

export default LegislativeWrapUp;
